import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useCerrarSesionMutation } from '../redux/api/cerrarSesion.api'
import { cerrarSesion } from '../redux/slices/autenticacion/autenticacion.slice'
import { deleteItemLocalStorageByKeys } from '../utils/StorageUtil'
import { AppConstantes } from '../utils/Constantes'

/**
 * Hook que gestiona el cierre de sesion: llama a API, limpia store y localStorage,
 * redirige a iniciar-sesion.
 */
export const useLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [cerrarSesionApi, { isLoading }] = useCerrarSesionMutation()

  const regresarInicio = () => {
    dispatch(cerrarSesion())
    deleteItemLocalStorageByKeys([AppConstantes.ACCESS_TOKEN, AppConstantes.REFRESH_TOKEN])
    navigate('iniciar-sesion')
  }

  const logout = () => {
    cerrarSesionApi({})
      .unwrap()
      .catch((error) => {
        console.error(error)
      })
    setTimeout(regresarInicio, 500)
  }

  return { logout, isLoading }
}
